export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item',
  password: 'avue_data'
}
export const url = 'https://data.bladex.vip/blade-visual'